/**
 * api/assistantApi.js — ХУВЬ ХҮНИЙ ТУСЛАХ
 *
 * Backend: Resources/XAB/assistant_today.py (/xab/assistant/*).
 */
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://hse.erdenetmc.mn/api",
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `SSO ${token}`;
  }
  return config;
});

export const assistantApi = {
  /** Өнөөдрийн ажил — хэсэг бүрийн тоо, эхний мөрүүд, ярих бичвэр */
  today: () => api.get("/xab/assistant/today").then((r) => r.data),
  /**
   * Туслахаас асуух — журмын хайлт + өнөөдрийн ажлыг эх сурвалж болгож AI
   * хариулна. AI унтраалттай бол `answer: null`, `sources`-оор л буцна.
   */
  chat: (q, history = []) =>
    api
      .post("/xab/assistant/chat", { q, history }, { timeout: 60000 })
      .then((r) => r.data),
  /**
   * Зөрчил арилгах даалгаврын АЛХАМ БҮРИЙН заавар + AI зөвлөгөө.
   * `id` нь /xab/my-assignments-ийн мөрийн id (21180 · asg-5 · haz-12).
   */
  /** ХАБЭА хэлтэс — туслахын сарын тайлан (суралцах давталт) */
  report: (month) =>
    api.get("/xab/assistant/report", { params: { month } }).then((r) => r.data),
  taskGuide: (id) =>
    api
      .get("/xab/assistant/task-guide", { params: { id }, timeout: 60000 })
      .then((r) => r.data),
};
